var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-form",class:_vm.templateClass},[_c('div',{staticClass:"t-form__title"},[_vm._t("title")],2),_c('div',{staticClass:"t-form__description"},[_vm._t("description")],2),_c('div',{staticClass:"t-form__body"},[_vm._t("body")],2),_c('div',{staticClass:"t-form__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }